<!-- prettier-ignore -->
<div class="content-input-increment">
  <div class="height">
    <div class="title"><ng-content select="[title]"></ng-content></div>
    <div class="label"><ng-content select="[label]"></ng-content></div>
  </div>
  <div class="actions">
    <span class="action" [ngClass]="{ 'disable': value === 0 || disable}" (click)="changeValue('dec')" ><mb-icon icon="sub"></mb-icon> </span>
    <span class="value">{{value}} </span>
    <span class="action"  [ngClass]="{ 'disable': value === 10 || disable }" (click)="changeValue('inc')"><mb-icon icon="add"></mb-icon></span>
  </div>
</div>
